window.addEventListener('DOMContentLoaded', (ev) => {

	$ = jQuery.noConflict();

	// for (const key in JEBlocks) {
	// 	if (JEBlocks.hasOwnProperty(key)) {
	// 		const block = JEBlocks[key];
	// 		block.init();
	// 	}
	// }

	for (const key in JEModules) {
		if (JEModules.hasOwnProperty(key)) {
			const block = JEModules[key];
			block.init();
		}
	}

	if (undefined !== window.JECustomBlocks && window.acf) {
		window.JECustomBlocks.forEach((b) => {
			let camelCasedName =
				'JE' +
				b.name
					.split('-')
					.map((el) => el.charAt(0).toUpperCase() + el.slice(1))
					.join('');

			window.acf.addAction(`render_block_preview/type=${b.name}`, JEBlocks[camelCasedName].init);
		});
	}
});

window.onload = function() {
	const tabButtons = document.querySelectorAll('.tabs__button');
	
		const tabPanels = document.querySelectorAll('.tabs__panel');
	
		function changeTab(selectedIndex) {
			tabButtons.forEach((button, index) => {
				if (index === selectedIndex) {
					button.setAttribute('aria-selected', 'true');
				} else {
					button.setAttribute('aria-selected', 'false');
				}
			});
	
			tabPanels.forEach((panel, index) => {
				if (index === selectedIndex) {
					panel.removeAttribute('hidden');
				} else {
					panel.setAttribute('hidden', 'hidden');
				}
			});
		}
	
		tabButtons.forEach((button, index) => {
			button.addEventListener('click', () => {
				changeTab(index);
			});
		});
	
		changeTab(0);
		};
